<template>
  <main class="main mobile_item_view" role="main">
    <div class="header_btn">
      <i
        class="pnt"
        :class="
          `i_h_like_${mobileProduct.isBookmark === 'Y' ? 'on' : 'off'}_big`
        "
        @click="toggleBookmark"
      ></i>
      <!-- <i class="i_share pnt"></i> -->
    </div>
    <div class="main_con">
      <div class="item_sec">
        <div class="sec_1">
          <div class="txt_1">{{ mobileProduct.modelName }}</div>
          <div class="txt_2">
            <div class="txt_2_1">{{ mobileProduct.releaseDate }} 출시</div>
            <!-- <div class="txt_2_2">
              출고가
              <span class="price">{{ formatNumber(676000) }}</span>
              <span class="won">원</span>
            </div> -->
          </div>
        </div>
        <div class="sec_2">
          <div class="device_img">
            <img
              v-if="mobileProduct.modelImage"
              :src="mobileProduct.modelImage"
              alt=""
            />
          </div>
          <div class="device_txt">
            <div class="txt_wrap mb">
              <div class="txt_title">색상</div>
              <div class="txt_color">
                <ul>
                  <li
                    v-for="(item, index) in mobileProduct.colors"
                    :key="index"
                  >
                    <div
                      class="color_li"
                      :style="`background-color:#${item.colorCode}`"
                    ></div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="txt_wrap">
              <div class="txt_title">OS버전</div>
              <div class="txt_con">{{ mobileProduct.os }}</div>
            </div>
            <!-- <div class="txt_wrap">
              <div class="txt_title">출시일</div>
              <div class="txt_con">2022-08-26</div>
            </div> -->
          </div>
        </div>
        <div class="sec_3">
          <div class="sec_3_wrap">
            <div class="list_con_wrap mb">
              <div class="list_con">
                <div class="con_img">
                  <img
                    :src="
                      require(`@/assets/front/images/mobile/ic_option_10.svg`)
                    "
                    alt=""
                  />
                </div>
                <div class="con_title">제원</div>
                <div class="con_txt">{{ mobileProduct.modelSize }}</div>
              </div>
              <div class="list_con">
                <div class="con_img">
                  <img
                    :src="
                      require(`@/assets/front/images/mobile/ic_option_02.svg`)
                    "
                    alt=""
                  />
                </div>
                <div class="con_title">RAM</div>
                <div class="con_txt">{{ mobileProduct.ram }}</div>
              </div>
              <div class="list_con">
                <div class="con_img">
                  <img
                    :src="
                      require(`@/assets/front/images/mobile/ic_option_03.svg`)
                    "
                    alt=""
                  />
                </div>
                <div class="con_title">배터리</div>
                <div class="con_txt">{{ mobileProduct.battery }}</div>
              </div>
            </div>
            <div class="list_con_wrap mb">
              <div class="list_con">
                <div class="con_img">
                  <img
                    :src="
                      require(`@/assets/front/images/mobile/ic_option_04.svg`)
                    "
                    alt=""
                  />
                </div>
                <div class="con_title">화면크기</div>
                <div class="con_txt">{{ mobileProduct.size }}</div>
              </div>
              <div class="list_con">
                <div class="con_img">
                  <img
                    :src="
                      require(`@/assets/front/images/mobile/ic_option_05.svg`)
                    "
                    alt=""
                  />
                </div>
                <div class="con_title">내장메모리</div>
                <div class="con_txt">{{ mobileProduct.memoryEmb }}</div>
              </div>
              <div class="list_con">
                <div class="con_img">
                  <img
                    :src="
                      require(`@/assets/front/images/mobile/ic_option_06.svg`)
                    "
                    alt=""
                  />
                </div>
                <div class="con_title">외장메모리</div>
                <div class="con_txt">{{ mobileProduct.memoryExt }}</div>
              </div>
            </div>
            <div class="list_con_wrap">
              <div class="list_con">
                <div class="con_img">
                  <img
                    :src="
                      require(`@/assets/front/images/mobile/ic_option_07.svg`)
                    "
                    alt=""
                  />
                </div>
                <div class="con_title">디스플레이</div>
                <div class="con_txt">{{ mobileProduct.display }}</div>
              </div>
              <div class="list_con">
                <div class="con_img">
                  <img
                    :src="
                      require(`@/assets/front/images/mobile/ic_option_08.svg`)
                    "
                    alt=""
                  />
                </div>
                <div class="con_title">CPU</div>
                <div class="con_txt">{{ mobileProduct.cpu }}</div>
              </div>
              <div class="list_con">
                <div class="con_img">
                  <img
                    :src="
                      require(`@/assets/front/images/mobile/ic_option_09.svg`)
                    "
                    alt=""
                  />
                </div>
                <div class="con_title">카메라</div>
                <div class="con_txt">{{ mobileProduct.camera }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="sec_4">
          <div class="list_con">
            <div class="con_txt mb">
              <div class="txt_1">간편결제</div>
              <div class="txt_2">{{ mobileProduct.payType }}</div>
            </div>
            <div class="con_txt mb">
              <div class="txt_1">지문인식</div>
              <div class="txt_2">{{ mobileProduct.fingerprint }}</div>
            </div>
            <div class="con_txt">
              <div class="txt_1">필름부착</div>
              <div class="txt_2">{{ mobileProduct.film }}</div>
            </div>
          </div>
          <div class="list_con">
            <div class="con_txt mb">
              <div class="txt_1">방수방진</div>
              <div class="txt_2">{{ mobileProduct.waterproof }}</div>
            </div>
            <div class="con_txt">
              <div class="txt_1">무선충전</div>
              <div class="txt_2">{{ mobileProduct.wirelessCharge }}</div>
            </div>
          </div>
        </div>
        <div class="line_sec"></div>
        <div class="sec_5">
          <div class="con_list mb">
            <div class="con_title">Special</div>
            <div
              class="con_txt"
              v-html="
                $options.filters.nl2br(
                  decodeBase64(mobileProduct.specialExplain),
                )
              "
            ></div>
          </div>
          <div class="con_list mb">
            <div class="con_title">Design</div>
            <div
              class="con_txt"
              v-html="
                $options.filters.nl2br(
                  decodeBase64(mobileProduct.designExplain),
                )
              "
            ></div>
          </div>
          <div class="con_list mb">
            <div class="con_title">Camera</div>
            <div
              class="con_txt"
              v-html="
                $options.filters.nl2br(
                  decodeBase64(mobileProduct.cameraExplain),
                )
              "
            ></div>
          </div>
          <div class="con_list">
            <div class="con_title">구성품</div>
            <div
              class="con_txt"
              v-html="
                $options.filters.nl2br(
                  decodeBase64(mobileProduct.componentExplain),
                )
              "
            ></div>
          </div>
        </div>
      </div>
    </div>

    <div class="btm_btn">
      <div class="btn_wrap">
        <button class="btn" @click="goMobile">
          견적 받아보기
        </button>
      </div>
    </div>
  </main>
</template>

<script>
import {
  mapActions as mobileMapActions,
  mapGetters as mobileMapGetters,
} from '@common/store/modules/mobile';
import * as mobileTypes from '@common/store/modules/mobile/types';

import * as util from '@common/lib/common/utils.js';

export default {
  name: 'ineternetcommerce-itemview',
  description: '인터넷 요금제 상세보기',
  components: {},
  data() {
    return {
      mobileProduct: [],
      isBookmark: 'Y',
    };
  },
  filters: {
    nl2br(val) {
      return String(val)
        .split('\n')
        .join('<br />');
    },
  },
  computed: {},
  async created() {
    await this.getItem();
  },
  methods: {
    ...mobileMapActions([
      mobileTypes.UPDATE_MOBILE_BOOKMARK,
      mobileTypes.UPDATE_MOBILE_SEL_PRODUCT,
    ]),
    decodeBase64(val) {
      return util.decodeBase64(val);
    },
    async getItem() {
      let mobileProductSelect = localStorage.getItem('mobileProductSelect');
      if (!mobileProductSelect) {
        this.mobileProduct = new Array();
      } else {
        this.mobileProduct = JSON.parse(mobileProductSelect);
      }

      console.log('this.mobileProduct');
      console.log(this.mobileProduct);
    },
    formatNumber(val) {
      return util.toCurrency(val);
    },
    goMobile() {
      localStorage.setItem('myMobileModelName', this.mobileProduct.modelName);
      // 상품 견적 카운트 증가
      this.upSelProductCnt();

      this.$router.push({
        name: 'Mobile.Create',
        query: {
          mode: 'MY_MOBILE',
        },
      });
    },
    upSelProductCnt() {
      const params = {
        modelId: this.mobileProduct.modelId,
      };
      console.log('params :: {}', params);
      this[mobileTypes.UPDATE_MOBILE_SEL_PRODUCT](params);
    },
    toggleBookmark() {
      if (this.mobileProduct.isBookmark === 'Y') {
        this.mobileProduct.isBookmark = 'N';
      } else {
        this.mobileProduct.isBookmark = 'Y';
      }
      this.setBookmark();
    },
    setBookmark() {
      // let params = { ...this.mobileProduct };
      let params = { modelId: this.mobileProduct.modelId };
      params.procType = this.mobileProduct.isBookmark === 'Y' ? 'ON' : 'OFF';
      this[mobileTypes.UPDATE_MOBILE_BOOKMARK](params);
      localStorage.setItem(
        'mobileProductSelect',
        JSON.stringify(this.mobileProduct),
      );
    },
  },
};
</script>

<style></style>
